/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Hear_QuestionInputs */

const en_onboarding_hear_question = /** @type {(inputs: Onboarding_Hear_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How did you hear about us?`)
};

const es_onboarding_hear_question = /** @type {(inputs: Onboarding_Hear_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo nos conociste?`)
};

/**
* | output |
* | --- |
* | "How did you hear about us?" |
*
* @param {Onboarding_Hear_QuestionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_hear_question = /** @type {((inputs?: Onboarding_Hear_QuestionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Hear_QuestionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_hear_question(inputs)
	return en_onboarding_hear_question(inputs)
});